import { useAuth0 } from "@auth0/auth0-react";

const requireAuth = process.env.REACT_APP_REQUIRE_AUTH === "true";

const defaults = {
  isAuthenticated: true,
  isLoading: false,
  error: undefined,
  loginWithRedirect: async () => {},
  logout: () => {},
  getAccessTokenSilently: async () => "",
  user: undefined,
};

export function useOptionalAuth0() {
  // Always call the hook unconditionally to satisfy React rules-of-hooks.
  const auth0 = useAuth0();

  if (!requireAuth) {
    return defaults;
  }
  return auth0;
}
